import post from '../../../../fns/http/post'
import getHeaders from './headers/index'

const loadCounters = (params, data, { urls, locale, headers, sessionId, responseProxy }) => {
    return post(`${urls.base.se}/search/count`, data, params, getHeaders({ locale, headers }), { responseProxy })
}
export default loadCounters
